import { render, staticRenderFns } from "./DefaultPaymentMethod.vue?vue&type=template&id=38240a71&"
import script from "./DefaultPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./DefaultPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports